module.exports = __webpack_public_path__ + "img/founders_08.d555a0c7.jpg";